export function getCookie(name) {
    if (!name) {
        return '';
    }
    var cookie = "" + document.cookie;
    var indexStart = cookie.indexOf(name + "=");
    if (indexStart === -1) {
        return '';
    }
    var indexEnd = cookie.indexOf(';', indexStart);
    if (indexEnd === -1) {
        indexEnd = cookie.length;
    }
    return decodeURIComponent(cookie.substring(indexStart + name.length + 1, indexEnd));
}
export function setCookie(name, value, days) {
    if (days === void 0) { days = 365; }
    var exp = new Date();
    exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toUTCString() + "; path=/; domain=.bilibili.com";
}
export function deleteCookie(name) {
    setCookie(name, '', -1);
}
export default {
    getCookie: getCookie,
    setCookie: setCookie,
    deleteCookie: deleteCookie,
};
//# sourceMappingURL=cookie.js.map